module.exports = __webpack_public_path__ + "img/call.fddeabd4.svg";